/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseOralExamCohortStateResponseData } from './genericApiResponseOralExamCohortStateResponseData';
import type { GenericApiResponseOralExamCohortStateResponseMessage } from './genericApiResponseOralExamCohortStateResponseMessage';
import type { GenericApiResponseOralExamCohortStateResponsePagination } from './genericApiResponseOralExamCohortStateResponsePagination';
import type { GenericApiResponseOralExamCohortStateResponseError } from './genericApiResponseOralExamCohortStateResponseError';

export interface GenericApiResponseOralExamCohortStateResponse {
  data?: GenericApiResponseOralExamCohortStateResponseData;
  message?: GenericApiResponseOralExamCohortStateResponseMessage;
  pagination?: GenericApiResponseOralExamCohortStateResponsePagination;
  error?: GenericApiResponseOralExamCohortStateResponseError;
  statusCode?: number;
}
